/* NANIMERICA · plays collector VIDEO reviews (Loox) wherever our own review cards show them.
   Loox's Shopify data only gives a video review's still frame (images.loox.io/.../<reviewId>_..._mid.jpg). The playable
   file lives on Cloudflare Stream; snippets/nr-rv-video prints the review id -> Stream id map from
   shop.metafields.nani.review_videos into window.nrRvVideos (add new video reviews there).
   - Cards (product page "Collector photos", homepage reviews rail, reviews page): a muted, looping preview plays over the
     still while the card is on screen (not with reduced motion). The "Video review" label stays on top.
   - Viewers (any <dialog> showing a review photo): when the photo is a video review's still, the video plays there with
     sound and controls instead; it pauses when the viewer closes or moves to another review.
   Nothing changes for photo reviews or for video reviews missing from the map (the still shows as before). */
(function () {
  if (window.nrRvVideoReady) return;
  window.nrRvVideoReady = true;
  var MAP = window.nrRvVideos || {};
  var IDS = Object.keys(MAP);
  if (!IDS.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function streamOf(src) {
    if (!src || String(src).indexOf('loox.io') < 0) return '';
    var file = String(src).split('?')[0].split('/').pop();
    for (var i = 0; i < IDS.length; i++) {
      if (file.indexOf(IDS[i] + '_') === 0) return MAP[IDS[i]];
    }
    return '';
  }
  function mp4(uid) { return 'https://videodelivery.net/' + uid + '/downloads/default.mp4'; }

  var style = document.createElement('style');
  style.textContent =
    '.nr-rvv{position:absolute;inset:0;z-index:1;width:100%;height:100%;object-fit:cover;pointer-events:none;background:transparent}' +
    '.nr-rvv-on ~ [class*="tag"],.nr-rvv-on ~ [class*="vid"],.nr-rvv-on ~ [class*="__on"]{z-index:2}' +
    '.nr-rvv-full{position:absolute;inset:0;z-index:2;display:block;width:100%;height:100%;object-fit:contain;background:#0e0e0f}';
  document.head.appendChild(style);

  /* ---- Card previews ---- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.src) v.src = v.getAttribute('data-pv');
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) v.pause();
    });
  }, { threshold: 0.5 }) : null;

  function scanCards(root) {
    if (reduce || !io) return;
    (root || document).querySelectorAll('img').forEach(function (img) {
      if (img.getAttribute('data-rvv')) return;
      if (img.closest('dialog') || img.closest('.nr-rq__img')) return;
      var uid = streamOf(img.getAttribute('src') || img.currentSrc);
      if (!uid) return;
      img.setAttribute('data-rvv', '1');
      var box = img.parentElement;
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      var v = document.createElement('video');
      v.className = 'nr-rvv';
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
      v.preload = 'none';
      v.setAttribute('data-pv', mp4(uid));
      v.poster = img.getAttribute('src');
      img.insertAdjacentElement('afterend', v);
      img.classList.add('nr-rvv-on');
      io.observe(v);
    });
  }

  /* ---- Viewers ---- */
  function mainImg(dlg) {
    return dlg.querySelector('[data-img], [data-v-img], .nrh-rvd__img img, img');
  }
  function syncDialog(dlg) {
    var img = mainImg(dlg);
    if (!img) return;
    var box = img.parentElement;
    var v = box.querySelector('video.nr-rvv-full');
    var uid = dlg.open ? streamOf(img.getAttribute('src')) : '';
    if (!uid) {
      if (v) { v.pause(); v.hidden = true; }
      img.style.visibility = '';
      return;
    }
    if (!v) {
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      v = document.createElement('video');
      v.className = 'nr-rvv-full';
      v.controls = true; v.playsInline = true; v.loop = true;
      v.setAttribute('playsinline', '');
      box.appendChild(v);
    }
    var src = mp4(uid);
    v.hidden = false;
    v.poster = img.getAttribute('src');
    if (v.getAttribute('src') !== src) v.src = src;
    img.style.visibility = 'hidden';
    v.muted = false;
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); });
  }
  function watchDialog(dlg) {
    if (dlg.getAttribute('data-rvv')) return;
    var img = mainImg(dlg);
    if (!img) return;
    dlg.setAttribute('data-rvv', '1');
    new MutationObserver(function () { syncDialog(dlg); }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    new MutationObserver(function () { syncDialog(dlg); }).observe(img, { attributes: true, attributeFilter: ['src'] });
    dlg.addEventListener('close', function () { syncDialog(dlg); });
  }

  function scan(root) {
    scanCards(root);
    document.querySelectorAll('dialog').forEach(watchDialog);
  }
  function start() {
    scan(document);
    var t = null;
    new MutationObserver(function (muts) {
      var added = muts.some(function (m) { return m.addedNodes && m.addedNodes.length; });
      if (!added) return;
      clearTimeout(t);
      t = setTimeout(function () { scan(document); }, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
